<div class="container-fluid">
    <h4 class="fw-bold mb-0 text-uppercase">Mot du Maire</h4>

    <section class="admin-mot-maire container my-5">
        <div class="card shadow-lg rounded-4 p-4 bg-light border-0">
            <div class="row g-4">

                <!-- Colonne image horizontal -->
                <div class="col-md-4 text-center d-flex flex-column align-items-center">
                    <div class="official-photo-container shadow-sm mx-auto my-3">
                        <img id="mairePhoto" [src]="previewImage" (error)="onImageError($event)" alt="Photo du Maire" class="img-fluid official-photo">
                    </div>


                    <button type="button" class="btn btn-outline-primary btn-sm mt-3" (click)="photoInput.click()">
                        <i class="pi pi-upload me-2"></i>Changer la photo
                    </button>

                    <input type="file" #photoInput id="photoInput" accept="image/*" style="display: none"
                        (change)="onFileSelected($event)">

                </div>

                <!-- Colonne formulaire -->
                <div class="col-md-8">
                    <form>
                        <div class="mb-3">
                            <label for="nom" class="form-label fw-bold">
                                <i class="pi pi-user text-success me-2"></i>Nom du Maire
                            </label>
                            <input [(ngModel)]="item.mayor_name" name="mayor_name" type="text" id="nom" class="form-control"
                                placeholder="Ex : M. Jean Dossou">
                        </div>

                        <div class="mb-3">
                            <label for="remerciement" class="form-label fw-bold">
                                <i class="pi pi-comment text-warning me-2"></i>Phrase de remerciement
                            </label>
                            <input [(ngModel)]="item.thank_you_phrase" name="remerciement" type="text" id="remerciement"
                                class="form-control" placeholder="Merci pour la confiance">
                        </div>

                        <div class="mb-3">
                            <label for="description" class="form-label fw-bold">
                                <i class="pi pi-pencil text-danger me-2"></i>Mot du Maire
                            </label>
                            <textarea [(ngModel)]="item.mayor_message" name="mot_maire" id="description" rows="6"
                                class="form-control" placeholder="Rédigez ici le mot du maire..."></textarea>
                        </div>

                        <button (click)="updateMotMaire()" type="submit" style="background-color: #145045;"
                            class="btn text-white w-100 rounded-pill mt-3">
                            <i class="pi pi-save me-2"></i>Enregistrer
                        </button>
                    </form>
                </div>

            </div>
        </div>
    </section>
</div>

<p-toast position="top-center" />
<ngx-ui-loader></ngx-ui-loader>